// ############################################################################
// ## UPLOADER + PHOTO EDITOR #################################################
// ############################################################################

export function uploaderEditable(opts) {
  var uploader = new Uploader.Uploader(opts.uploader);

  if(opts.onFirstUpload && !uploader.model.items.length) {
    uploader.model.on("file:upload_done", opts.onFirstUpload);
  }

  var photoEditor = new PhotoEditor(opts.editor);

  uploader.model.on("file:rotate", function(evt) {
    var model = evt.target;
    model.file.data.filter = true;
  });

  uploader.view.on("item:zoom", function(evt) {
    var model = evt.target.model;
    if(!model.isStatic()) {
      alert(opts.fileNotUploadedMessage);
      return;
    }
    var url = model.file.full;
    photoEditor.opts.urlPrefix = opts.getEditorUrlPrefix(model);
    photoEditor.open(url, { hasFilters: !!model.file.data.filter });
    photoEditor.onclose = function() {
      if(photoEditor.history.hasUndo()) model.file.data.filter = true;
      model.setUrl(); // update preview
    };
  });

  return {
    getUploader: function() { return uploader; },
    getEditor: function() { return photoEditor; }
  };
}
